import React from "react";

const SentCheckIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5ZM14.1278 8.34855C14.5274 7.96733 14.5423 7.33434 14.1611 6.93473C13.7798 6.53512 13.1468 6.52022 12.7472 6.90145L8.85215 10.6174L7.25339 9.08954C6.8541 8.70797 6.2211 8.72233 5.83954 9.12161C5.45797 9.5209 5.47233 10.1539 5.87161 10.5355L8.16068 12.723C8.54697 13.0921 9.15523 13.0924 9.54176 12.7236L14.1278 8.34855Z"
      fill="currentColor"
    />
  </svg>
);

export default SentCheckIcon;
